import { render, staticRenderFns } from "./SettingRole.vue?vue&type=template&id=f9c07220&scoped=true&"
import script from "./SettingRole.vue?vue&type=script&lang=js&"
export * from "./SettingRole.vue?vue&type=script&lang=js&"
import style0 from "./SettingRole.vue?vue&type=style&index=0&id=f9c07220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c07220",
  null
  
)

export default component.exports